import { useEffect } from 'react';
import { Card } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { removeHttpToken } from '../utilities/http';
import { removeToken } from '../utilities/utils';

function ErrorBoundary() {
  const user = useSelector((state) => state.user);
  const roleId = user?.role?.id;

  useEffect(() => {
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);

  const handleClick = () => {
    removeToken();
    removeHttpToken();
    window.location.href = '/';
  };

  return (
    <div className="pos-fixed ht-100p wd-100p bg-black-5 z-index-200 tx-white d-flex align-items-center justify-content-center">
      <Card>
        <Card.Body>
          <h4 className="tx-center mg-b-30 mg-b-0-f">
            {roleId ? (
              <>
                Enhance your experience by logging in again -{' '}
                <button
                  type="button"
                  onClick={handleClick}
                  style={{
                    color: 'white',
                    background: '#6d4175',
                    borderRadius: '5px',
                    fontSize: '20px',
                    border: 'none',
                    padding: '8px',
                  }}
                >
                  Click Here
                </button>
              </>
            ) : (
              'Something went wrong. Please refresh/try after some time'
            )}
          </h4>
        </Card.Body>
      </Card>
    </div>
  );
}

export default ErrorBoundary;
